module.exports = __webpack_public_path__ + "img/moving-number.60a99118.svg";